class CountdownTimer extends BaseHTMLElement {
  constructor() {
    super();
    this.startCount(this);
  }

  getUTCDateNow() {
    var date = new Date();
    var now_utc = Date.UTC(
      date.getUTCFullYear(),
      date.getUTCMonth(),
      date.getUTCDate(),
      date.getUTCHours(),
      date.getUTCMinutes(),
      date.getUTCSeconds(),
    );
    return new Date(now_utc);
  }

  startCount(countdownWrapper) {
    var endDate = countdownWrapper.getAttribute('data-end');
    var timeZone = countdownWrapper.getAttribute('data-timezone');
    var splitEndDate = endDate.split(',');
    var TimeZoneSymbole = timeZone.slice(0, 1);
    var TimeZoneValue = Number(timeZone.slice(1)) * 3600000;
    if (countdownWrapper) {
      var endTime = new Date(
        Date.UTC(
          Number(splitEndDate[0]),
          Number(splitEndDate[1]) - 1,
          Number(splitEndDate[2]),
          Number(splitEndDate[3]),
          Number(splitEndDate[4]),
          Number(splitEndDate[5]),
        ),
      ).getTime();
      if (TimeZoneSymbole === '-') {
        endTime += TimeZoneValue;
      } else {
        endTime -= TimeZoneValue;
      }
      var timer = setInterval(() => {
        var now = this.getUTCDateNow().getTime();
        var left = endTime - now;
        var days = Math.floor(left / (1000 * 60 * 60 * 24));
        var hours = Math.floor((left % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((left % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((left % (1000 * 60)) / 1000);

        if (days < 10) {
          days = '0' + days;
        }

        if (hours < 10) {
          hours = '0' + hours;
        }

        if (minutes < 10) {
          minutes = '0' + minutes;
        }

        if (seconds < 10) {
          seconds = '0' + seconds;
        }

        var daysFieldFirst = countdownWrapper.querySelector('[data-counter-day-first]');
        var daysFieldSecond = countdownWrapper.querySelector('[data-counter-day-second]');

        var hourFieldFirst = countdownWrapper.querySelector('[data-counter-hour-first]');
        var hourFieldSecond = countdownWrapper.querySelector('[data-counter-hour-second]');

        var minuteFieldFirst = countdownWrapper.querySelector('[data-counter-minute-first]');
        var minuteFieldSecond = countdownWrapper.querySelector('[data-counter-minute-second]');

        var secondFieldFirst = countdownWrapper.querySelector('[data-counter-second-first]');
        var secondFieldSecond = countdownWrapper.querySelector('[data-counter-second-second]');

        var splitdaysField = days.toString().split('');
        var splitHourField = hours.toString().split('');
        var splitMinuteField = minutes.toString().split('');
        var splitSecondField = seconds.toString().split('');

        daysFieldFirst.innerHTML = splitdaysField[0];
        daysFieldSecond.innerHTML = splitdaysField[1];

        hourFieldFirst.innerHTML = splitHourField[0];
        hourFieldSecond.innerHTML = splitHourField[1];

        minuteFieldFirst.innerHTML = splitMinuteField[0];
        minuteFieldSecond.innerHTML = splitMinuteField[1];

        secondFieldFirst.innerHTML = splitSecondField[0];
        secondFieldSecond.innerHTML = splitSecondField[1];

        if (left < 0) {
          clearInterval(timer);
          countdownWrapper.classList.add('d-none');
          countdownWrapper.closest('.all-countdown-slide-wrap').classList.add('d-none');
        }
      }, 1000);
    }
  }
}
if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
